<template>
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 10.6667L20 10.6667M20 10.6667C20 12.8758 21.7909 14.6667 24 14.6667C26.2091 14.6667 28 12.8758 28 10.6667C28 8.45752 26.2091 6.66666 24 6.66666C21.7909 6.66666 20 8.45752 20 10.6667ZM12 21.3333L28 21.3333M12 21.3333C12 23.5425 10.2091 25.3333 8 25.3333C5.79086 25.3333 4 23.5425 4 21.3333C4 19.1242 5.79086 17.3333 8 17.3333C10.2091 17.3333 12 19.1242 12 21.3333Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
